export const compareStrings = (a: string, b: string) => {
    const nameA = a.toLowerCase();
    const nameB = b.toLowerCase();
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
};
